import React from "react";
import { MapPin, Clock, Phone, Navigation } from "lucide-react";

const LOCATIONS = [
  {
    name: "Udupi",
    slug: "udupi",
    heading: "Bike Rental in Udupi",
    image:
      "https://images.unsplash.com/photo-1519750292352-c9fc17322ed7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxzY29vdGVyJTIwcmlkaW5nfGVufDB8fHx8MTc4NTgxMjQ4M3ww&ixlib=rb-4.1.0&q=85",
    address:
      "Karavali Junction, Karthik Trade Centre, Opp. New KSRTC Bus Stop, Udupi-576102",
    timing: "Mon-Sun: 07:30 AM - 07:30 PM",
    phone: "+91 70677 06719",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Karavali+Junction+Karthik+Trade+Centre+New+KSRTC+Bus+Stop+Udupi+576102",
  },
  {
    name: "Manipal",
    slug: "manipal",
    heading: "Scooty Rental in Manipal",
    image:
      "https://images.unsplash.com/photo-1776021808492-e7a7de58c580?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxtb3BlZCUyMGNvYXN0YWx8ZW58MHx8fHwxNzg1ODEyNDg4fDA&ixlib=rb-4.1.0&q=85",
    address:
      "Shambavi Soverign, Next to Country INN, End Pt. Road, Manipal",
    timing: "Mon-Sun: 09:00 AM - 07:30 PM",
    phone: "+91 70677 06719",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Shambavi+Soverign+End+Point+Road+Manipal+Country+INN",
  },
];

const Locations = () => {
  return (
    <section id="branches" className="py-20 lg:py-28 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-orange-600 font-bold text-sm uppercase tracking-[0.2em]">
            Visit Us
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-black text-neutral-900 leading-tight tracking-tight">
            Bike Rental{" "}
            <span className="text-orange-500">
              Branches in Udupi &amp; Manipal
            </span>
          </h2>
          <p className="mt-4 text-neutral-600">
            Two convenient branches. Walk in during office hours or call ahead
            to reserve your scooter.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {LOCATIONS.map((l) => (
            <article
              key={l.slug}
              id={`branch-${l.slug}`}
              className="bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all border border-neutral-100"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={l.image}
                  alt={`RR Bros Bike Rental ${l.name} branch — ${l.heading} at ${l.address}`}
                  loading="lazy"
                  decoding="async"
                  className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-4 left-5 right-5 text-white">
                  <div className="inline-flex items-center gap-1.5 bg-orange-500 text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-2">
                    <MapPin className="w-3 h-3" /> Branch
                  </div>
                  <h3 className="text-3xl font-black tracking-tight">
                    {l.name}
                  </h3>
                  <p className="text-xs text-neutral-200 font-semibold mt-0.5">
                    {l.heading}
                  </p>
                </div>
              </div>

              <div className="p-5 sm:p-6 space-y-3 text-sm text-neutral-700">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                  <address className="not-italic leading-relaxed">
                    {l.address}
                  </address>
                </div>
                <div className="flex items-center gap-3">
                  <Clock className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <span>{l.timing}</span>
                </div>
                <a
                  href={`tel:${l.phone.replace(/\s/g, "")}`}
                  className="flex items-center gap-3 hover:text-orange-600 transition-colors font-semibold"
                >
                  <Phone className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <span>{l.phone}</span>
                </a>

                <div className="pt-3 grid grid-cols-2 gap-2">
                  <a
                    href={l.mapsUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center justify-center gap-1.5 h-10 rounded-full bg-neutral-900 hover:bg-neutral-800 text-white text-xs font-bold uppercase tracking-wider transition-colors"
                  >
                    <Navigation className="w-3.5 h-3.5" />
                    Get Directions
                  </a>
                  <a
                    href={`tel:${l.phone.replace(/\s/g, "")}`}
                    className="inline-flex items-center justify-center gap-1.5 h-10 rounded-full bg-orange-500 hover:bg-orange-600 text-white text-xs font-bold uppercase tracking-wider transition-colors"
                  >
                    <Phone className="w-3.5 h-3.5" />
                    Call Branch
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;
